import React from 'react';
import { ButtonGroup, Button, Dropdown } from 'react-bootstrap';
import { FaTh, FaList } from 'react-icons/fa';

const SortingSection = ({   viewMode,
  setViewMode,
  sortOption,
  setSortOption,
  activeType,
  setActiveType }) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-4 sort-section">
      {/* <Dropdown>
        <Dropdown.Toggle variant="light" id="sortDropdown">
          Sort by: {getSortOptionLabel(sortOption)}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() => setSortOption('deals')}
            active={sortOption === 'deals'}
          >
            Deals
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => setSortOption('price-high')}
            active={sortOption === 'price-high'}
          >
            Price High to Low
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => setSortOption('price-low')}
            active={sortOption === 'price-low'}
          >
            Price Low to High
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => setSortOption('duration-long')}
            active={sortOption === 'duration-long'}
          >
            Duration Long to Short
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => setSortOption('duration-short')}
            active={sortOption === 'duration-short'}
          >
            Duration Short to Long
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown> */}
<div className="d-flex gap-2">
  <Button
    variant={activeType === "tour" ? "primary" : "outline-primary"}
    onClick={() => setActiveType("tour")}
  >
    Tour
  </Button>

  <Button
    variant={activeType === "fit" ? "primary" : "outline-primary"}
    onClick={() => setActiveType("fit")}
  >
    FIT
  </Button>
  <Button
  variant={activeType === "all" ? "primary" : "outline-primary"}
  onClick={() => setActiveType("all")}
>
  All
</Button>
</div>

      <ButtonGroup className="view-toggle">
        <Button
          variant={viewMode === 'grid' ? 'primary' : 'outline-primary'}
          onClick={() => setViewMode('grid')}
        >
          <FaTh className="me-1" /> Grid
        </Button>
        <Button
          variant={viewMode === 'list' ? 'primary' : 'outline-primary'}
          onClick={() => setViewMode('list')}
        >
          <FaList className="me-1" /> List
        </Button>
      </ButtonGroup>
    </div>
  );
};

// Helper function to get readable sort option label
const getSortOptionLabel = (option) => {
  switch (option) {
    case 'deals': return 'Deals';
    case 'price-high': return 'Price High to Low';
    case 'price-low': return 'Price Low to High';
    case 'duration-long': return 'Duration Long to Short';
    case 'duration-short': return 'Duration Short to Long';
    default: return 'Deals';
  }
};

export default SortingSection;
